/**
 * Anne Klein Horizon global pause bus (WCAG 2.2 2.2.2).
 * Ported from LottoSport.com. Storage key ada-global-pause; events ada-global-pause:*.
 * Default on when prefers-reduced-motion: reduce and no saved preference.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ada-global-pause';
  var customHandlers = new Set();
  var isPaused = false;

  function announce(paused) {
    var live = document.getElementById('ak-ada-pause-live');
    if (!live) return;
    live.textContent = '';
    window.requestAnimationFrame(function () {
      live.textContent = paused ? 'Animations paused' : 'Animations playing';
    });
  }

  function syncButtons(paused) {
    document.querySelectorAll('.ada-global-pause-toggle, .ak-ada-pause-toggle').forEach(function (btn) {
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Resume animations' : 'Pause animations');
      btn.classList.toggle('is-paused', paused);
      btn.classList.toggle('active', paused);
      var pauseIcon = btn.querySelector('.ak-ada-icon-pause');
      var playIcon = btn.querySelector('.ak-ada-icon-play');
      if (pauseIcon) pauseIcon.hidden = !!paused;
      if (playIcon) playIcon.hidden = !paused;
    });
  }

  function setPaused(paused, persist) {
    isPaused = !!paused;
    if (persist !== false) {
      localStorage.setItem(STORAGE_KEY, isPaused ? 'on' : 'off');
    }
    customHandlers.forEach(function (handler) {
      try {
        if (isPaused) handler.pause();
        else handler.resume();
      } catch (e) {
        /* ignore handler errors */
      }
    });
    syncButtons(isPaused);
    document.documentElement.setAttribute('data-global-pause', isPaused ? 'on' : 'off');
    announce(isPaused);
    document.dispatchEvent(
      new CustomEvent('ada-global-pause:changed', { detail: { paused: isPaused } })
    );
  }

  function registerCustom(handler) {
    if (!handler || typeof handler.pause !== 'function' || typeof handler.resume !== 'function') {
      return;
    }
    customHandlers.add(handler);
    if (isPaused) {
      try {
        handler.pause();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function unregisterCustom(handler) {
    customHandlers.delete(handler);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.ada-global-pause-toggle, .ak-ada-pause-toggle');
    if (!btn) return;
    event.preventDefault();
    setPaused(!isPaused);
  });

  window.ADA_GlobalPause = {
    registerCustom: registerCustom,
    unregisterCustom: unregisterCustom,
    pauseAll: function () {
      setPaused(true);
    },
    resumeAll: function () {
      setPaused(false);
    },
    isPaused: function () {
      return isPaused;
    },
  };

  var saved = localStorage.getItem(STORAGE_KEY);
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  setPaused(saved === 'on' || (saved == null && reduceMotion), false);

  document.dispatchEvent(new CustomEvent('ada-global-pause:ready', { detail: { paused: isPaused } }));
})();
